import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'
import validatePatente from 'common/backend/validatePatente'
import { REACT_APP_COTIZADOR_API } from '../../config'

export async function getCotizacion(params) {
  const { year, brand, brandId, model, modelId, version, versionId, patente, km } = params
  if (patente && !validatePatente(patente)) {
    throw new Error('La patente no es válida')
  }

  const body_cotizador = {
    costs: [
      {
        type: 'general',
        amount: 0,
      },
      {
        type: 'cubiertas',
        amount: 0,
      },
    ],
    interior: 5, // 10: excelente, 5: bueno, 0: malo
    kms: km,
    licencePlate: patente,
    vehicle: {
      brand: brandId,
      brandName: brand,
      model: modelId,
      modelName: model,
      version: versionId,
      versionName: version,
      year: year,
    },
  }
  const cotizacion = await axios
    .post(REACT_APP_COTIZADOR_API + '/cotizador/v1/quotes', body_cotizador)
    .then((res) => res.data)
    .catch(err => err?.response?.data)

  return deepFreeze(cotizacion)
}
